import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import styles from "./ProcessSetup.module.css";
import { useNavigate } from "react-router-dom";
import {
  Dropdown,
  InputField,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";

const { Option } = Select;

const ProcessSetup = () => {
  const navigate = useNavigate();
  const [process, setprocess] = useState("");
  const [isModal, setIsModal] = useState(false);
  const [EditModal, setEditModal] = useState(false);
  const [autoParameter, setAutoParameter] = useState("");
  const [autoValue, setAutoValue] = useState("");
  const [dataType, setDataType] = useState();

  const [stations, setStations] = useState([
    { name: "Mixing", checked: true },
    { name: "Oven", checked: true },
    { name: "Proof", checked: true },
    { name: "Chill", checked: true },
    { name: "Assembly", checked: false },
    { name: "Packaging", checked: false },
    { name: "Make Up", checked: false },
  ]);

  const handleToggle = (name) => {
    setStations((prev) =>
      prev.map((item) =>
        item.name === name ? { ...item, checked: !item.checked } : item
      )
    );
  };

  const [parameters, setParameters] = useState([
    { id: 1, name: "Bake Temperature (Fahrenheit)", dataType: "Numeric" },
    { id: 2, name: "Time (minutes)", dataType: "Numeric" },
    { id: 3, name: "Qc Check", dataType: "Upload" },
  ]);

  const handleEdit = (id) => {
    console.log("Edit parameter", id);
  };

  const handleRemove = (id) => {
    setParameters(parameters.filter((p) => p.id !== id));
  };

  const handleAdd = () => {
    const newParameter = {
      id: Date.now(),
      name: "New Parameter",
      dataType: "Text",
    };
    setParameters([...parameters, newParameter]);
  };

  const DropdownOptions = [
    {
      value: "Numeric",
      id: 1,
    },
    {
      value: "Text",
      id: 2,
    },
    {
      value: "Numeric Range",
      id: 3,
    },
    {
      value: "Check Box",
      id: 4,
    },
    {
      value: "Media Upload",
      id: 5,
    },
  ];

  const ProcessSetup = ({ stations, onToggle }) => {
    return (
      <div className={styles.container}>
        <TextComponent text={"Station"} className={styles.Heading} />
        <div className={styles.checkboxRow}>
          {stations.map((item, index) => (
            <div
              key={index}
              className={styles.checkboxItem}
              onClick={() => onToggle(item.name)}
            >
              <div
                className={`${styles.checkbox} ${
                  item.checked ? styles.checked : ""
                }`}
              >
                {item.checked && <span className={styles.checkmark}>✓</span>}
              </div>
              <span
                className={`${styles.label} ${
                  !item.checked ? styles.disabled : ""
                }`}
              >
                {item.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.subCont}>
        <div className={styles.row}>
          <div className={styles.leftCont}>
            <InputField
              label={"Process Name"}
              style={{ marginTop: "10px" }}
              placeholder={"Flour Dough"}
              value={process}
              onChange={(e) => setprocess(e.target.value)}
            />
          </div>

          <div className={styles.rightCont}>
            <ProcessSetup stations={stations} onToggle={handleToggle} />
          </div>
        </div>

        <div className={styles.container}>
          <h2 className={styles.heading}>Finished Process Parameters</h2>

          <div className={styles.tableRow}>
            <div className={styles.tableHeader}>Parameters</div>
            <div className={styles.tableHeader}>Data</div>
            <div className={styles.tableHeader}></div>
          </div>

          {parameters.map((param) => (
            <div key={param.id} className={styles.tableRow}>
              <div className={styles.cell}>{param.name}</div>
              <div className={styles.cell}>{param.dataType}</div>
              <div className={styles.buttonGroup}>
                <SubmitButton
                  title={"Edit"}
                  style={{ width: "100%" }}
                  btnContainerClass={styles.btnsDiv}
                  primary
                  // onClick={() => handleEdit(param.id)}
                   onClick={() => setEditModal(true)}

                />
                <SubmitButton
                  title={"Remove"}
                  style={{ width: "100%" }}
                  btnContainerClass={styles.btnsDiv}
                  secondary
                  onClick={() => handleRemove(param.id)}
                />
              </div>
            </div>
          ))}
          <SubmitButton
            title={"Add Parameter"}
            btnClass={styles.addParameterBtn}
            btnContainerClass={styles.addParameterBtnDiv}
            primary
            onClick={() => setIsModal(true)}
          />
        </div>
      </div>
      <Modal
        open={isModal}
        onClickOkButton={() => {
          setIsModal(false);
        }}
        onCancel={() => setIsModal(false)}
        className={styles.modalCont}
        title={"Add Parameter"}
        width={"400px"}
        buttonTitle={"Add"}
        btnStyle={{ width: "200px" }}
        onBtnPress={() => setIsModal(false)}
      >
        <div className={styles.modalInnerCont}>
          <div className={styles.modalRow}>
            <TextComponent
              fontFamily={"Inter-semiBold"}
              className={styles.modalText}
              text={"Parameter"}
            />
            <InputField
              placeholder={"Steam (seconds)"}
              innerInput={{}}
              className={styles.inputNew}
              value={autoParameter}
              onChange={(e) => setAutoParameter(e.target.value)}
            />
          </div>
          <div className={styles.modalRow}>
            <TextComponent
              fontFamily={"Inter-semiBold"}
              className={styles.modalText}
              text={" Data"}
            />
            <Dropdown
              value={dataType}
              labelStyle={{ fontSize: 18 }}
              className={styles.inputNew}
              style={{ color: "black" }}
              options={DropdownOptions}
              onChange={(e) => setDataType(e)}
            />
          </div>
        </div>
      </Modal>

      {/* ========= EditModal =====  */}
      <Modal
        open={EditModal}
        onClickOkButton={() => {
          setEditModal(false);
        }}
        onCancel={() => setEditModal(false)}
        className={styles.modalCont}
        title={"Add Parameter"}
        width={"400px"}
        buttonTitle={"Add"}
        btnStyle={{ width: "200px" }}
        onBtnPress={() => setEditModal(false)}
      >
        <div className={styles.modalInnerCont}>
          <div className={styles.modalRow}>
            <TextComponent
              fontFamily={"Inter-semiBold"}
              className={styles.modalText}
              text={"Parameter"}
            />
            <InputField
              placeholder={"Steam (seconds)"}
              innerInput={{}}
              className={styles.inputNew}
              value={autoParameter}
              onChange={(e) => setAutoParameter(e.target.value)}
            />
          </div>
          <div className={styles.modalRow}>
            <TextComponent
              fontFamily={"Inter-semiBold"}
              className={styles.modalText}
              text={" Data"}
            />
            <Dropdown
              value={dataType}
              labelStyle={{ fontSize: 18 }}
              className={styles.inputNew}
              style={{ color: "black" }}
              options={DropdownOptions}
              onChange={(e) => setDataType(e)}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ProcessSetup;
